import { TabItem } from '@/components/ui/tab';
import { BonusTypeItem, Sport, StatusItem } from '@/types';
export type ViewMode = 'time' | 'competitions';
export const imagekit = import.meta.env.VITE_IMAGEKIT_URL;
const isMobile = window.innerWidth < 640;
export const DefineIcons = [
  {
    id: 1,
    title: 'Profile',
    isImage: true,
    icon: `${imagekit}/downline/profile.svg`,
  },
  {
    id: 2,
    title: 'Sport Permission',
    isImage: true,
    icon: `${imagekit}/downline/sportpermission.svg`,
  },
  {
    id: 3,
    title: 'Betting PL',
    isImage: true,
    icon: `${imagekit}/downline/deposit.svg`,
  },
  {
    id: 4,
    title: 'Withdraw',
    isImage: false,
    icon: 'W',
    iconClassName: 'bg-yellow-700 text-white',
  },
  {
    id: 5,
    title: 'Deposit',
    isImage: false,
    icon: 'D',
    iconClassName: 'bg-green text-white',
  },
  {
    id: 6,
    title: 'Password Change',
    isImage: true,
    icon: `${imagekit}/downline/lock.svg`,
  },
  {
    id: 7,
    title: 'Change Status',
    isImage: true,
    icon: `${imagekit}/downline/changestatus.svg`,
  },
  {
    id: 8,
    title: 'Bet History',
    isImage: true,
    icon: `${imagekit}/downline/history.svg`,
  },
  {
    id: 9,
    title: 'Self registered',
    isImage: false,
    icon: '👤',
  },
  {
    id: 10,
    title: 'Created by Upline',
    isImage: false,
    icon: '🛡️',
  },
];

export const badgeConfig: Record<string, { code: string; bg: string }> = {
  'super admin': { code: 'SA', bg: 'bg-primary' },
  agent: { code: 'AG', bg: 'bg-green2' },
  'super master': { code: 'SM', bg: 'bg-pink' },
  master: { code: 'MA', bg: 'bg-[#FEB759]' },
  user: { code: 'C', bg: 'bg-brown' },
  banker: { code: 'BA', bg: 'bg-purple' },
  owner: { code: 'OW', bg: 'bg-blue' },
};

export const initialSports: Sport[] = [
  { id: 1, name: 'Cricket', active: true },
  // { id: 2, name: 'Soccer', active: true },
  // { id: 3, name: 'Tennis', active: true },
  // { id: 4, name: 'Election', active: true },
  // { id: 5, name: 'Grayhound', active: true },
  // { id: 6, name: 'HorseRacing', active: true },
  { id: 4, name: 'Casino', active: true },
];

export const STATUS_OPTIONS: StatusItem[] = [
  { label: 'Active', value: 'Active', color: 'dark-green' },
  { label: 'Inactive', value: 'Inactive', color: 'red-700' },
  { label: 'Suspended', value: 'Suspended', color: 'pink' },
  { label: 'Bet Lock', value: 'BetLock', color: 'purple' },
];

export enum UserRole {
  ADMIN = 'ADMIN',
  BANKER = 'BANKER',
  USER = 'USER',
}

export const paymentTabs = [
  {
    id: 'Easypaisa',
    name: 'Easy Paisa',
    colorActive: 'bg-green border-green3 text-white',
    colorInActive: 'bg-white border border-green3 text-[#E2136E]',
    icon: '/bKash.svg',
  },
  {
    id: 'Jazzcash',
    name: 'Jazz cash',
    colorActive: 'bg-green border-green3 text-white',
    colorInActive: 'bg-white border border-green3 text-[#EA1C2D]',
    icon: '/nagad.svg',
  },
];

export const tabList: TabItem[] = [
  { id: 'qr', label: 'Manage QR' },
  { id: 'account', label: 'Manage Account' },
  { id: 'crypto', label: 'Manage Crypto' },
];

export const accountTabList: TabItem[] = [
  { id: 'all', label: 'All' },
  { id: 'upi', label: 'UPI' },
  { id: 'bank', label: 'Bank Account' },
  { id: 'crypto', label: 'Crypto' },
];

export const dwTabs: TabItem[] = [
  { id: 'Credit', label: 'Deposit' },
  { id: 'Debit', label: 'Withdraw' },
];

export const bankerDetailTab: TabItem[] = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'd-w-request', label: 'Deposit/Withdraw Requests' },
  { id: 'account-statement', label: 'Account Statement' },
];

export const eventManageTab: TabItem[] = [
  { id: 'import', label: 'InActive Matches' },
  { id: 'inplay', label: 'InPlay' },
  { id: 'upcoming', label: 'Upcoming' },
];

export const statusColor = {
  active: 'text-dark-green bg-light',
  inactive: 'bg-red-300 text-red-600',
  bet_lock: 'text-[#837800] bg-[#FEF9C3]',
  suspended: 'text-brown bg-[#FFEBCC]',
} as const;

export const dotColor = {
  active: 'bg-dark-green',
  inactive: 'bg-red-500',
  bet_lock: 'bg-yellow-500',
  suspended: 'bg-orange-500',
} as const;

export const CasinoTabs: TabItem[] = [
  {
    id: 'category',
    label: isMobile ? 'Category' : 'Category Level',
  },
  {
    id: 'provider',
    label: isMobile ? 'Provider' : 'Provider Level',
  },
  {
    id: 'game',
    label: isMobile ? 'Game' : 'Game Control',
  },
];
export const BetListTab: TabItem[] = [
  { id: 'Direct', label: 'Platform Users' },
  { id: 'Hierarchy', label: 'Hierarchy Users' },
];

export const InactiveMemberTab: TabItem[] = [
  { id: 'Direct', label: 'Platform Users' },
  { id: 'Hierarchy', label: 'Hierarchy' },
];
export const transectiionTypes: TabItem[] = [
  { id: 'Deposit/Withdraw', label: 'Deposit/Withdraw' },
  { id: 'Game Transaction', label: 'Game Transaction' },
];
export const contentManagementTabs = [
  {
    id: 1,
    label: 'Banner Management',
    img: `${imagekit}/contentManagement/banner.svg`,
  },
  {
    id: 2,
    label: 'Notification Management',
    img: `${imagekit}/contentManagement/notification.svg`,
  },
  {
    id: 3,
    label: 'Support Contact Management',
    img: `${imagekit}/contentManagement/support.svg`,
  },
];

export const managementTabs = [
  {
    id: 1,
    label: 'Banner Management',
    path: '/content-management',
    btn: '+ Add Banner',
    img: `${imagekit}/contentManagement/banner.svg`,
  },
  {
    id: 2,
    label: 'Notification Management',
    btn: '+ Add Notification',
    path: '/content-management/notification-management',
    img: `${imagekit}/contentManagement/notification.svg`,
  },
  // {
  //   id: 3,
  //   label: 'Support Contact Management',
  //   btn: '',
  //   path: '/content-management/support-management',
  //   img: `${imagekit}/contentManagement/support.svg`,
  // },
];

export const Sports: TabItem[] = [
  { label: 'All', id: 'All' },
  { label: 'Cricket', id: 'Cricket' },
  { label: 'Soccer', id: 'Soccer' },
  { label: 'Tennis', id: 'Tennis' },
  // { label: 'Grayhound', id: 'Greyhound' },
  // { label: 'Horse Race', id: 'HorseRacing' },
];

export const EventTabs: TabItem[] = [
  { label: 'Sports', id: 'Sports' },
  { label: 'Casino', id: 'Casino' },
];

export const SportsTabs: TabItem[] = [
  { label: 'Cricket', id: 'Cricket' },
  { label: 'Soccer', id: 'Soccer' },
  { label: 'Tennis', id: 'Tennis' },
  // { label: 'Horse Racing', id: 'HorseRacing' },
  // { label: 'Greyhound', id: 'Greyhound' },
];
export const instructions1 = [
  { id: 1, text: 'User deposits:₹1,000' },
  { id: 2, text: 'Bonus percentage: 555%' },
  { id: 3, text: 'Bonus credited:₹5,550' },
  { id: 4, text: 'Release requirement:₹10,000 total turnover' },
];
export const instructions2 = [
  { id: 1, text: 'Referred user deposits: 1,000' },
  { id: 2, text: 'Referrer bonus: 50% = 500' },
  { id: 3, text: 'New user bonus: 30% = 300' },
];

export const instructions3 = [
  { id: 1, text: 'Referred users net losses: 5,000' },
  { id: 2, text: 'Commission percentage: 10%' },
  { id: 3, text: 'Referrer earns: 500' },
  { id: 4, text: 'Payout frequency: weekly' },
];
export const instructions4 = [
  { id: 1, text: 'Loss threshold: 100,000' },
  { id: 2, text: 'Users monthly net losses: 100,000' },
  { id: 3, text: 'Cashback percentage: 10%' },
  { id: 4, text: 'Cashback amount: 10,000' },
  { id: 5, text: 'Credited to: Bonus Wallet' },
];
export const instructions5 = [
  { id: 1, text: 'User recharges: 1,000' },
  { id: 2, text: 'Bonus percentage: 10%' },
  { id: 3, text: 'Bonus credited: 100' },
  { id: 4, text: 'Release requirement: 8,000 total turnover' },
];
export const bonustypes: BonusTypeItem[] = [
  {
    label: 'Joining Bonus',
    value: 'JoiningBonus',
    icon: `${imagekit}/bonus/join.svg`,
  },
  {
    label: 'Referral Bonus',
    value: 'ReferralBonus',
    icon: `${imagekit}/bonus/refrral.svg`,
  },
  {
    label: 'Referral Loss Commission',
    value: 'ReferralLossCommissionBonus',
    icon: `${imagekit}/bonus/refLoss.svg`,
  },
  {
    label: 'Loss-Back Bonus',
    value: 'LossBackBonus',
    icon: `${imagekit}/bonus/losback.svg`,
  },
  {
    label: 'Refill Bonus',
    value: 'DepositBonus',
    icon: `${imagekit}/bonus/refil.svg`,
  },
];
export const BussinessReportTabs: TabItem[] = [
  { label: 'First Deposit', id: 'FIRST' },
  { label: 'Refill Deposit', id: 'REFILL' },
];
export const STATUS_LOGOUT_MESSAGES: Record<string, string> = {
  inactive: 'Your account has been deactivated. You have been logged out.',
  suspended: 'Your account has been suspended. You have been logged out.',
  bet_lock: 'Betting has been locked on your account. You have been logged out.',
};
export const toUTCISOString = (localDateTime?: string): string | undefined => {
  if (!localDateTime) return undefined;

  const date = new Date(localDateTime);

  if (isNaN(date.getTime())) return undefined;

  return date.toISOString();
};
// src/constants/roles.ts

// src/constants/roles.ts

export const ROLES = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const;

export type RoleName = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_GROUPS = {
  CAN_MANAGE_USERS: [ROLES.OWNER, ROLES.ADMIN],
  CAN_VIEW_REPORTS: [ROLES.OWNER, ROLES.ADMIN],
} as const;

// ✅ Updated to handle undefined/null
export const hasRole = (
  userRole: string | undefined | null,
  allowedRoles: readonly string[]
): boolean => {
  if (!userRole) return false;
  return allowedRoles.includes(userRole);
};

export const isOwner = (role: string | undefined | null) => role === ROLES.OWNER;
export const isAdmin = (role: string | undefined | null) => role === ROLES.ADMIN;
export const isDownlineUser = (role: string | undefined | null) => {
  if (!role) return false;

  return ['SUPER ADMIN', 'ADMIN', 'AGENT', 'SUB SUPER MASTER', 'MASTER'].includes(role);
};
export const isRoleUser = (role: string | undefined | null) => {
  if (!role) return false;

  return !['OWNER', 'SUPER ADMIN', 'ADMIN', 'AGENT', 'SUB SUPER MASTER', 'MASTER'].includes(role);
};

export const sports = {
  Cricket: 'Cricket',
  // Soccer: 'Soccer',
  // Tennis: 'Tennis',
  // 'Grey hound': 'Greyhound',
  // 'Horse Racing': 'HorseRacing',
};
type SportKey = keyof typeof sports;

export const getSportValue = (sport: string) => {
  return sports[sport as SportKey] ?? sport;
};
